import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  objectSearchErrorTitle: {
    id: 'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title',
    defaultMessage: "We couldn't fetch any results for this search",
    description: 'Error title informing the user that there was an error while fetching CMDB objects in customer portal create view'
  },
  objectSearchErrorDescription: {
    id: 'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description',
    defaultMessage: 'Ask your team or admin for support.',
    description: 'Error message informing user the potential issues of failing CMDB object search in customer portal create view'
  }
});